export default __webpack_public_path__ + "static/thayles-ed8c5beadf3173890b99273399eb49ad.png";